export const isFetchReportLoading = state => state.report.isFetchReportLoading || false;
export const isCreatingReport = state => state.report.isCreatingReport || false;
